module.exports = __webpack_public_path__ + "img/fero_blue.f434e78e.png";